import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import DataService from './dataservice';
import mode from './store/modules/mode';

Vue.use(Vuex);

const FRONT_AUTH_ROLES = ['Client', 'Freelancer'];

function normalizeRole(value) {
  return String(value || '')
    .trim()
    .toLowerCase();
}

/** Client / Freelancer only — admin & other roles are guests on marketing UI. */
export function isClientOrFreelancer(user) {
  if (!user || typeof user !== 'object') {
    return false;
  }

  const candidates = [user.current_profile, user.user_type, user.userdetails?.user_type];

  return candidates.some(role =>
    FRONT_AUTH_ROLES.some(allowed => normalizeRole(role) === normalizeRole(allowed))
  );
}

function clearLocalAuthArtifacts() {
  try {
    localStorage.removeItem('token');
  } catch (e) {
    /* ignore */
  }
  delete axios.defaults.headers.common['Authorization'];
}

export default new Vuex.Store({
  modules: {
    mode,
  },
  state: {
    ref_notification: 0,
    status: '',
    token: localStorage.getItem('token') || '',
    appBootstrapLoaded: false,
    appContext: null,
    proposal_id: null,
    class_id: null,
    user: false,
    hireProjectId: sessionStorage.getItem('ProjectId'),
    hireProjectName: sessionStorage.getItem('ProjectName'),
    hireUserId: sessionStorage.getItem('HireUserId'),

    domainid: sessionStorage.getItem('domainid'),
    categoryid: sessionStorage.getItem('categoryid'),
    projectid: sessionStorage.getItem('projectid'),

    /// project section start///
    frontProjectId: sessionStorage.getItem('ProjectId'),
    frontProjectName: sessionStorage.getItem('ProjectName'),

    /// end ////

    //3. Start  Order Details Section
    orderid: sessionStorage.getItem('orderid'),
    ordertype: sessionStorage.getItem('ordertype'),
    //End Order Details
    // popup chat box
    openchat: 0,
  },
  mutations: {
    setDomainid: (state, domainid) => {
      sessionStorage.setItem('domainid', domainid);
      state.domainid = domainid;
    },
    setCategoryid: (state, categoryid) => {
      sessionStorage.setItem('categoryid', categoryid);
      state.categoryid = categoryid;
    },
    setNoti: (state, data) => {
      state.ref_notification = data;
    },

    setHireProjectId: (state, projectid) => {
      state.hireProjectId = projectid;
      sessionStorage.setItem('ProjectId', projectid);
    },
    setHireProjectName: (state, projectname) => {
      state.hireProjectName = projectname;
      sessionStorage.setItem('ProjectName', projectname);
    },
    setHireUserId: (state, userId) => {
      state.hireUserId = userId;
      sessionStorage.setItem('HireUserId', userId);
    },

    /// Project section ///
    setProjectid: (state, projectid) => {
      sessionStorage.setItem('projectid', projectid);
      state.projectid = projectid;
    },
    setProjectname: (state, projectname) => {
      sessionStorage.setItem('projectname', projectname);
      state.projectname = projectname;
    },
    setProjectType: (state, projectType) => {
      sessionStorage.setItem('projectType', projectType);
      state.projectType = projectType;
    },

    /// end ///

    //Start Order Details section //
    setOrderid: (state, orderid) => {
      sessionStorage.setItem('orderid', orderid);
      state.orderid = orderid;
    },
    setOrdertype: (state, ordertype) => {
      sessionStorage.setItem('ordertype', ordertype);
      state.ordertype = ordertype;
    },
    //End Order Details  //

    auth_request(state) {
      state.status = 'loading';
    },
    auth_success(state, token) {
      state.status = 'success';
      state.token = token;
    },
    setAppBootstrapLoaded(state, value) {
      state.appBootstrapLoaded = value;
    },
    setAppContext(state, data) {
      state.appContext = data;
    },
    auth_error(state) {
      state.status = 'error';
    },
    logout(state) {
      state.status = '';
      state.token = '';
      state.user = false;
      state.appBootstrapLoaded = false;
      state.appContext = null;
      clearLocalAuthArtifacts();
    },
    clearFrontSession(state) {
      state.status = '';
      state.token = '';
      state.user = false;
      clearLocalAuthArtifacts();
    },
    slogin(state, token) {
      localStorage.setItem('token', token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      state.status = 'success';
      state.token = token;
    },
    setUpdateUser(state, data) {
      state.user = data;
    },
    Proposal_Id(state, data) {
      state.proposal_id = data;
    },

    SetClassId(state, data) {
      state.class_id = data;
    },
    setOpenChat(state, data) {
      state.openchat = data;
    },
  },
  actions: {
    initializeAppContext({ commit, state }) {
      if (state.appBootstrapLoaded) {
        return Promise.resolve(state.appContext);
      }

      if (state.token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${state.token}`;
      }

      return new Promise(resolve => {
        DataService.appBootstrap()
          .then(response => {
            const payload = response.data || {};
            const rawUser = payload.user || false;
            const onAdminSurface =
              typeof window !== 'undefined' &&
              (window.location.pathname.startsWith('/admin') ||
                document.body?.classList?.contains('admin-us'));

            // Admin surfaces keep whatever bootstrap returned.
            if (onAdminSurface) {
              if (Array.isArray(rawUser?.permissions) && rawUser.permissions.length) {
                window.Permissions = rawUser.permissions;
              } else {
                window.Permissions = window.Permissions || [];
              }
              commit('setUpdateUser', rawUser);
              commit('setAppContext', payload);
              commit('setAppBootstrapLoaded', true);
              resolve(payload);
              return;
            }

            const frontUser = isClientOrFreelancer(rawUser) ? rawUser : false;

            // Not a Client/Freelancer session → clear local auth and show Login / Sign up
            if (!frontUser) {
              const hadSession = !!(rawUser || state.token || payload?.auth?.authenticated);
              commit('clearFrontSession');
              window.Permissions = [];
              if (hadSession) {
                fetch('/logout', { method: 'GET', credentials: 'same-origin' }).catch(() => {});
              }
            } else if (Array.isArray(frontUser.permissions) && frontUser.permissions.length) {
              window.Permissions = frontUser.permissions;
            } else {
              window.Permissions = window.Permissions || [];
            }

            commit('setUpdateUser', frontUser);
            commit('setAppContext', payload);
            commit('setAppBootstrapLoaded', true);
            resolve(payload);
          })
          .catch(() => {
            window.Permissions = [];
            commit('clearFrontSession');
            commit('setAppContext', null);
            commit('setAppBootstrapLoaded', true);
            resolve(null);
          });
      });
    },
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        DataService.gettoken()
          .then(response => {
            DataService.login(user)
              .then(response => {
                const token = response.data.access_token;
                localStorage.setItem('token', token);
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                commit('auth_success', token);
                commit('setUpdateUser', response.data.user || false);
                window.Permissions = [];
                commit('setAppBootstrapLoaded', false);
                resolve(response);
              })
              .catch(error => {
                commit('auth_error');
                localStorage.removeItem('token');
                reject(error);
              });
          })
          .catch(error => {
            commit('auth_error');
            localStorage.removeItem('token');
            reject(error);
          });
      });
    },

    adminlogin({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        DataService.gettoken()
          .then(response => {
            DataService.adminlogin(user)
              .then(response => {
                const token = response.data.access_token;
                localStorage.setItem('token', token);
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                commit('auth_success', token);
                commit('setUpdateUser', response.data.user || false);
                commit('setAppBootstrapLoaded', false);
                resolve(response);
              })
              .catch(error => {
                commit('auth_error');
                localStorage.removeItem('token');
                reject(error);
              });
          })
          .catch(error => {
            commit('auth_error');
            localStorage.removeItem('token');
            reject(error);
          });
      });
    },

    accountlogin({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        DataService.gettoken()
          .then(response => {
            DataService.accountlogin(user)
              .then(response => {
                const token = response.data.access_token;
                localStorage.setItem('token', token);
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                commit('auth_success', token);
                commit('setUpdateUser', response.data.user || false);
                commit('setAppBootstrapLoaded', false);
                resolve(response);
              })
              .catch(error => {
                commit('auth_error');
                localStorage.removeItem('token');
                reject(error);
              });
          })
          .catch(error => {
            commit('auth_error');
            localStorage.removeItem('token');
            reject(error);
          });
      });
    },

    accountregister({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        DataService.accountregister(user)
          .then(resp => {
            const token = resp.data.token;
            const user = resp.data.user;
            localStorage.setItem('token', token);
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            commit('auth_success', user);
            resolve(resp);
          })
          .catch(err => {
            commit('auth_error', err);
            localStorage.removeItem('token');
            reject(err);
          });
      });
    },

    register({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        DataService.register(user)
          .then(resp => {
            const token = resp.data.token;
            const user = resp.data.user;
            localStorage.setItem('token', token);
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            commit('auth_success', user);
            resolve(resp);
          })
          .catch(err => {
            commit('auth_error', err);
            localStorage.removeItem('token');
            reject(err);
          });
      });
    },

    chatbox({ commit }, data) {
      commit('setOpenChat', data);
    },
  },
  getters: {
    //domainid:state=>state.domainid,
    //categoryid:state=>state.categoryid,

    isLoggedIn(state) {
      return isClientOrFreelancer(state.user);
    },
    getAppContext: state => state.appContext,
    getUser: state => state.user,
    authStatus: state => state.status,
    getProposalId: state => {
      return state.proposal_id;
    },
    getClassId: state => {
      return state.class_id;
    },
  },
});
